"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressResponseDto = void 0;
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
/**
 * Data Transfer Object for Address Response.
 */
class AddressResponseDto {
}
exports.AddressResponseDto = AddressResponseDto;
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", Object)
], AddressResponseDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", Number)
], AddressResponseDto.prototype, "addressTypeLid", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", String)
], AddressResponseDto.prototype, "address1", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", Number)
], AddressResponseDto.prototype, "countryId", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", Number)
], AddressResponseDto.prototype, "stateId", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", Number)
], AddressResponseDto.prototype, "cityId", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", String)
], AddressResponseDto.prototype, "address2", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", String)
], AddressResponseDto.prototype, "area", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", String)
], AddressResponseDto.prototype, "pinCode", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", String)
], AddressResponseDto.prototype, "phoneNumber", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", String)
], AddressResponseDto.prototype, "alternatePhoneNumber", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", String)
], AddressResponseDto.prototype, "email", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Expose)(),
    tslib_1.__metadata("design:type", String)
], AddressResponseDto.prototype, "supportNumber", void 0);
